import styles from './index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { BatchImagesContext } from '../BatchImagesContext.js'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import API from "@api/api";
import PSAIModal from "@PSAIComponents/PSAIModal";
import Utils from '@utils/utils';
import UploadBox from '../components/UploadBox/index.jsx'
import { Drawer, Progress, message } from "antd"
import { UPLOAD_SOURCE, BATCH_IMAGES_TYPE } from "@utils/CONST"
import { AppContext } from '@utils/AppContext';
import TableWrap from './table.jsx'
import FooterBar from './FooterBar.jsx'
import SmartDetailPageConfigBar, { INITIAL_SMART_DETAIL_ITEMS } from './components/SmartDetailPageConfigBar'
import SelectTryonPose from '../components/SelectTryonPose'

const SMART_DETAIL_COMP_CATEGORY_MAP = {
    poster: 'heroPoster',
    sellingPoint: 'sellingPoints',
    buyerShow: 'buyerShow',
    sceneStyling: 'lifestyleOutfit',
    productInfo: 'productInfo',
    productDetail: 'productDetails',
    sizeChart: 'sizeChart',
    serviceGuarantee: 'shoppingGuarantee',
}

const ConfigPage = () => {
    const { fileList, setFileList, setUploadImgToSkuId, uploadImgToSkuId } = useContext(BatchImagesContext)
    const { globalUser } = useContext(AppContext)
    const navigate = useNavigate()
    const { isProCenter } = useLocation().state || {}
    const location = useLocation()
    const [uploading, setUploading] = useState(false)
    const [uploadFileList, setUploadFileList] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [errorOpen, setErrorOpen] = useState(false)
    const [errorList, setErrorList] = useState([])
    const [successList, setSuccessList] = useState([])
    const [allUploadFail, setAllUploadFail] = useState(false)
    const isMounted = useRef(true)
    const { projectId } = useParams()
    const [projectType, setProjectType] = useState("")
    const [projectName, setProjectName] = useState("")
    const [total, setTotal] = useState(0) // 用户选完素材后生成图总数
    const [skuId, setSkuId] = useState("")
    const [taskId, setTaskId] = useState("")
    const [projectSerial, setProjectSerial] = useState("")
    const uploadMaxNumber = useRef(10)
    const isFusionLikeProject = useMemo(() => {
        return [
            BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
            BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
        ].includes(projectType)
    }, [projectType])

    // 再次编辑取参数
    const isEdit = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const skuId = params.get('skuId');
        const taskId = params.get('taskId');

        if (skuId) setSkuId(skuId)
        if (taskId) setTaskId(taskId)
        if (skuId && taskId) return true
    }, [location.search])

    const concurrentSku = useRef(50)
    useEffect(() => {
        concurrentSku.current = globalUser?.membership?.concurrentSku || 50
    }, [globalUser])


    // sku列表
    const listSkuByProject = async (editCurrentData) => {
        if (editCurrentData?.length === 0 || !editCurrentData) {
            try {
                const res = await API.listSkuByProject({
                    projectId,
                    skuId,
                    taskId,
                })
                if (res?.code == -5003) navigate("/home/product/batchImages")
                if (res.code === -5067) { navigate('/home/product/batchImages'); return }
                if (res.code !== 0) throw new Error(res.message)
                const skuList = res?.data?.skuDetailList || [];
                setProjectType(res?.data?.projectType);
                setProjectName(res?.data?.projectName);
                setProjectSerial(res?.data?.projectSerial);
                setTotal(res?.data?.total || 0)
                setDataSource(res?.data?.projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? skuList.map(item => normalizeSmartDetailSku(item)) : [...skuList])
            } catch (err) {
                message.error(err.message || "请求失败");
            }
        } else {
            setDataSource(projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? editCurrentData.map(item => normalizeSmartDetailSku(item)) : [...editCurrentData])
        }
    };

    useEffect(() => {
        listSkuByProject()
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    // 遍历获取AI试衣列表中的服装类型
    const checkedSkuRef = useRef([]);
    useEffect(() => {
        if (isEdit) return;
        if (projectType !== BATCH_IMAGES_TYPE.TRYON_BATCH || !dataSource || dataSource.length === 0 || uploading) return;

        const unprocessed = dataSource.filter(item => {
            const mainCloth = item?.inputImages?.find(img => img.mainImage === true);
            return (
                mainCloth &&
                (mainCloth.clothType == null || mainCloth.clothType === '') &&
                item.skuId && !checkedSkuRef.current.includes(item.skuId)
            );
        });

        if (unprocessed.length === 0) return;

        const getClothType = async () => {
            for (const item of unprocessed) {
                if (!isMounted.current) break;
                checkedSkuRef.current.push(item.skuId);
                console.log('checkedSkuRef.current', checkedSkuRef.current)

                const mainCloth = item.inputImages.find(img => img.mainImage === true);
                if (!mainCloth?.url) {
                    checkedSkuRef.current = checkedSkuRef.current.filter(id => id !== item.skuId);
                    continue;
                }

                try {
                    const clothRes = await API.getClothType({ imageUrl: mainCloth.url });
                    if (clothRes?.code === 0) {
                        const newType = clothRes.data;
                        mainCloth.clothType = newType;

                        setDataSource(prev =>
                            prev.map(it => {
                                if (it.skuId !== item.skuId) return it;
                                const newImages = it.inputImages.map(img =>
                                    img.mainImage ? { ...img, clothType: newType } : img
                                );
                                return { ...it, inputImages: newImages, projectId };
                            })
                        );

                        checkedSkuRef.current = checkedSkuRef.current.filter(id => id !== item.skuId);
                    }
                } catch (err) {
                    console.error('getClothType error', err);
                }
            }
        };
        getClothType();
    }, [projectType, dataSource, uploading, isEdit]);

    // 遍历获取同款换色列表中的服装类型
    const checkedSkuRef2 = useRef([]);
    useEffect(() => {
        if (
            projectType !== BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
            !dataSource ||
            dataSource.length === 0 ||
            uploading
        ) return;

        const unprocessed = dataSource.filter(item => {
            return (
                item.inputCloth &&
                item.flatType !== 'material' &&
                (item.clothType == null || item.clothType === '') &&
                item.skuId &&
                !checkedSkuRef2.current.includes(item.skuId)
            );
        });

        if (unprocessed.length === 0) return;

        const getClothType = async () => {
            for (const item of unprocessed) {
                if (!isMounted.current) break;

                checkedSkuRef2.current.push(item.skuId);

                if (!item.inputCloth) {
                    checkedSkuRef2.current = checkedSkuRef2.current.filter(
                        id => id !== item.skuId
                    );
                    continue;
                }

                try {
                    const clothRes = await API.getClothType({
                        imageUrl: item.inputCloth,
                    });

                    if (clothRes?.code === 0) {
                        const newType = clothRes.data;

                        setDataSource(prev =>
                            prev.map(it => {
                                if (it.skuId !== item.skuId) return it;
                                return {
                                    ...it,
                                    clothType: newType,
                                };
                            })
                        );

                        // 从checkedSkuRef2中移除对应的skuId
                        checkedSkuRef2.current = checkedSkuRef2.current.filter(id => id !== item.skuId);
                    }
                } catch (err) {
                    console.error('getClothType error', err);
                }
            }
        };

        getClothType();
    }, [projectType, dataSource, uploading]);

    useEffect(() => {
        if (dataSource.length === 0) return
        API.batchSaveSku(normalizeDataSourceForSave(dataSource)).then(res => {
            if (res?.code == 0) {

            } else {
                throw new Error(res.message)
            }
        }).catch(err => message.error(err.message))
    }, [dataSource, projectType, smartDetailConfigItems])

    useEffect(() => {
        if (fileList.length > 0 && projectType) {
            handleUpload(fileList)
        }
    }, [fileList, projectType])


    // 首次批量上传
    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    const handleUpload = async (fileList, targetSkuId) => {
        console.log('fileList', fileList)
        const smartPageUrlList = [] // 服装详情页成功上传的图
        let smartPageSkuName = ''
        const errorList = []
        const successList = []
        const currentSkuId = targetSkuId || uploadImgToSkuId
        setErrorList([...errorList])
        setSuccessList([...successList])

        // 再次编辑不可上传素材
        if (isEdit && !isFusionLikeProject) return

        try {
            setUploading(true)
            // 详情页最多支持上传50张图
            if (isFusionLikeProject) {
                uploadMaxNumber.current = projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? 5 : 10
                if (fileList.length > uploadMaxNumber.current) {
                    message.info(`最多只能上传${uploadMaxNumber.current}张搭配图，将自动截取前${uploadMaxNumber.current}张`, 5)
                }
                fileList = [...fileList].slice(0, uploadMaxNumber.current)
            } else {
                fileList = [...fileList].slice(0, concurrentSku.current)
            }

            setUploadFileList(fileList)

            for (let file of fileList) {
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                try {
                    if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
                        await Utils.validateImageFileToVideo(file, true) // 视频首帧图仅支持jpg、png
                    } else {
                        await Utils.validateImageFile(file, true)
                    }
                } catch (err) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                // 详情页支持10K图，单张不超过40M
                let resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                

                if (!resizeRes || !resizeRes.success) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                } else file = resizeRes.file
                if (uploadAbort.current) { uploadAbort.current = false; break; }


                // 上传图片
                const res = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.BATCHIMAGES)
                if (!res || !res.isLegal) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                // 详情页、搭配上身需要将上传图保存到同一个sku
                if (isFusionLikeProject) {
                    smartPageSkuName = removeExtension(file.name)
                    const url = res.data
                    smartPageUrlList.push({
                        url: url,
                        mainImage: true
                    })
                    successList.push({ url, name: smartPageSkuName })
                    setSuccessList([...successList])
                } else {
                    // 添加源素材到具体任务、保存单个sku
                    const url = res.data
                    const skuName = removeExtension(file.name)
                    API.batchSaveSku([{
                        projectId: projectId,
                        projectType: projectType,
                        skuName: skuName,
                        skuId: '',
                        inputImages: [{
                            url: url,
                            mainImage: true
                        }]
                    }]).then(res => {
                        if (res?.code == 0) {
                            listSkuByProject()
                            successList.push({ url, name: skuName })
                            setSuccessList([...successList])
                        } else if (res?.code == -5065) {
                            message.error(`上传已终止，每个项目最多上传${concurrentSku.current}件商品！`, 5000)
                            handleUploadAbort()
                        } else {
                            throw new Error(res.message)
                        }
                    }).catch(err => message.error(err.message))
                }
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            if (isFusionLikeProject && smartPageUrlList.length > 0) {

                const targetSku = dataSource.find(item => item.skuId === currentSkuId);
                const existingImages = currentSkuId && Array.isArray(targetSku?.inputImages) ? targetSku.inputImages : []
                const mergedImages = [...existingImages, ...smartPageUrlList]

                if (mergedImages.length > uploadMaxNumber.current) { // 数量超出时优先截掉本次新增
                    message.info(`最多只能上传${uploadMaxNumber.current}张搭配图，已自动截取前${uploadMaxNumber.current}张`, 5)
                }
                const nextImages = projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
                    ? normalizeSmartDetailInputImages(mergedImages.slice(0, uploadMaxNumber.current))
                    : mergedImages.slice(0, uploadMaxNumber.current)

                if (isEdit) { // 编辑时候不能直接save，要先存起来发起时候才会生效
                    console.log('smartPageUrlList', nextImages)
                    setDataSource(dataSource.map(item => {
                        if (item.skuId === currentSkuId) {
                            const nextItem = {
                                ...item,
                                inputImages: nextImages
                            }
                            return projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? normalizeSmartDetailSku(nextItem) : nextItem
                        }
                        return item
                    }))
                } else {
                    API.batchSaveSku([normalizeSkuForSave({
                        ...targetSku,
                        projectId: projectId,
                        projectType: projectType,
                        skuName: targetSku?.skuName || smartPageSkuName,
                        skuId: currentSkuId ? currentSkuId : '',
                        inputImages: nextImages
                    })]).then(res => {
                        if (res?.code == 0) {
                            listSkuByProject()
                        } else if (res?.code == -5065) {
                            message.error(`上传已终止，每个项目最多上传${concurrentSku.current}件商品！`, 5000)
                            handleUploadAbort()
                        } else {
                            throw new Error(res.message)
                        }
                    }).catch(err => message.error(err.message))
                }
            }
            setFileList([])
            setErrorList([...errorList])
            setSuccessList([...successList])
            setUploading(false)
            setUploadImgToSkuId()
            // 全部图片上传失败
            setAllUploadFail(fileList.length == errorList.length)
            // 图片上传失败弹窗
            if (errorList.length > 0) setErrorOpen(true)
        }
    }

    // 上传图片
    const handleReupload = () => {
        setUploadOpen(true)
        setErrorOpen(false)
    }
    const handleCancel = () => {
        setErrorList([])
        setErrorOpen(false)
    }
    const handleGoBack = () => {
        if (dataSource.length === 0) {
            API.batchRemoveProject({
                projectIds: [projectId],
            }).then(res => {
                if (res?.code == 0) {
                    navigate("/home/product/batchImages")
                } else throw new Error(res.message)
            })
        } else {
            navigate("/home/product/batchImages")
        }
    }
    // 正在上传的图片
    const remainUploadLength = useMemo(() => {
        return successList.length + errorList.length
    }, [uploadFileList, successList, errorList])

    // 上传更多
    const [uploadOpen, setUploadOpen] = useState(false)
    const uploadDebounceRef = useRef(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [showSelectionColumn, setShowSelectionColumn] = useState(false)
    const footerBarRef = useRef(null)
    const [modelDrawerOpen, setModelDrawerOpen] = useState(false)
    const [selectedModelList, setSelectedModelList] = useState([])
    const [smartDetailConfigItems, setSmartDetailConfigItems] = useState(INITIAL_SMART_DETAIL_ITEMS)
    const [smartDetailReferLoading, setSmartDetailReferLoading] = useState(false)

    const buildSmartDetailCustomCompList = (itemList = INITIAL_SMART_DETAIL_ITEMS) => {
        return itemList.map((item) => ({
            category: SMART_DETAIL_COMP_CATEGORY_MAP[item.key],
            num: item.fixed || item.enabled ? Number(item.value) || 0 : 0,
        })).filter((item) => !!item.category)
    }

    const normalizeSmartDetailInputImages = (inputImages = []) => {
        const nextImages = (Array.isArray(inputImages) ? inputImages : [])
            .map((item) => ({
                url: item?.url,
                mainImage: !!(item?.mainImage || item?.isMainImage),
            }))
            .filter((item) => !!item.url)

        if (!nextImages.length) return []

        const mainIndex = nextImages.findIndex((item) => item.mainImage)
        const targetMainIndex = mainIndex >= 0 ? mainIndex : 0
        return nextImages.map((item, index) => ({
            url: item.url,
            mainImage: index === targetMainIndex,
        }))
    }

    const normalizeSmartDetailSku = (sku, customItems = smartDetailConfigItems) => {
        const { modelList, ...restSku } = sku || {}
        const inputImages = normalizeSmartDetailInputImages(sku?.inputImages)
        return {
            ...restSku,
            inputImages,
            refList: Array.isArray(sku?.refList) ? sku.refList : (Array.isArray(sku?.modelList) ? sku.modelList : []),
            customCompList: buildSmartDetailCustomCompList(customItems),
        }
    }

    const normalizeSkuForSave = (sku, customItems = smartDetailConfigItems) => {
        if (projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) return sku
        return normalizeSmartDetailSku(sku, customItems)
    }

    const normalizeDataSourceForSave = (list = dataSource, customItems = smartDetailConfigItems) => {
        if (projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) return list
        return list.map((item) => normalizeSmartDetailSku(item, customItems))
    }

    const getSmartDetailNum = (data) => {
        if (typeof data === 'number') return data
        if (Array.isArray(data)) return Number(data?.[0]?.pre_count ?? data?.[0]?.num ?? data?.[0]?.count ?? data?.[0]?.imageNum ?? data.length) || 0
        if (data && typeof data === 'object') return Number(data.num ?? data.count ?? data.imageNum ?? data.total) || 0
        return 0
    }
    const handleAddMore = (file, fileList, skuId) => {
        if (uploadDebounceRef.current) {
            clearTimeout(uploadDebounceRef.current)
        }
        uploadDebounceRef.current = setTimeout(() => {
            handleUpload(fileList, skuId)
            setUploadOpen(false)
        }, 100)
    }
    // 停止上传
    const uploadAbort = useRef(false)
    const handleUploadAbort = () => {
        setFileList([])
        uploadAbort.current = true
    }

    const handleOpenSmartDetailModelDrawer = () => {
        setModelDrawerOpen(true)
    }

    const handleSmartDetailModelChange = (value) => {
        setSelectedModelList([...(value || [])])
        setModelDrawerOpen(false)
    }

    const handleSmartDetailConfigChange = (updater) => {
        setSmartDetailConfigItems((prev) => {
            const nextItems = typeof updater === 'function' ? updater(prev) : updater
            setDataSource((prevData) => prevData.map((item) => (
                item?.projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
                    ? normalizeSmartDetailSku(item, nextItems)
                    : item
            )))
            return nextItems
        })
    }

    // 服装详情页从我的项目中选图上传
    const tableRef = useRef(null)
    const handleMyProjectUpload = (urlList, callBack) => {
        const smartPageUrlList = []
        urlList.map(item => {
            smartPageUrlList.push({
                url: item.results?.[0].image,
                mainImage: true
            })
        })
        const targetSku = dataSource.find(item => item.skuId === uploadImgToSkuId);
        const existingImages = uploadImgToSkuId && Array.isArray(targetSku?.inputImages) ? targetSku.inputImages : []
        const mergedImages = [...existingImages, ...smartPageUrlList]

        const maxCount = projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? 5 : 50
        if (mergedImages.length > maxCount) {
            message.info(`最多只能上传${maxCount}张详情图，已自动截取前${maxCount}张`)
        }
        const nextImages = projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
            ? normalizeSmartDetailInputImages(mergedImages.slice(0, maxCount))
            : mergedImages.slice(0, maxCount)

        if (isEdit) { // 编辑时候不能直接save，要先存起来发起时候才会生效
            setDataSource(dataSource.map(item => {
                if (item.skuId === uploadImgToSkuId) {
                    const nextItem = {
                        ...item,
                        inputImages: nextImages
                    }
                    return projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? normalizeSmartDetailSku(nextItem) : nextItem
                }
                return item
            }))
            tableRef.current.setUploadOpen(false)
            callBack(false)
            setUploadImgToSkuId()
        } else {
            API.batchSaveSku([normalizeSkuForSave({
                projectId: projectId,
                projectType: projectType,
                skuName: '未命名',
                skuId: uploadImgToSkuId ? uploadImgToSkuId : '',
                inputImages: nextImages
            })]).then(res2 => {
                if (res2?.code == 0) {
                    tableRef.current.setUploadOpen(false)
                    callBack(false)
                    listSkuByProject()
                    setUploadImgToSkuId()
                } else throw new Error(res2.message)

            }).catch(err => message.error(err.message))
        }
    }

    return (
        <>
            <div className={styles.ConfigPage}>
                <TableWrap
                    ref={tableRef}
                    dataSource={dataSource}
                    onMyProjectUpload={handleMyProjectUpload}
                    projectSerial={projectSerial}
                    isProCenter={isProCenter}
                    setDataSource={setDataSource}
                    listSkuByProject={listSkuByProject}
                    projectType={projectType}
                    projectId={projectId}
                    uploading={uploading}
                    projectName={projectName}
                    total={total}
                    isEdit={isEdit} // 是否是重新编辑
                    editSkuId={skuId} // 重新编辑时
                    editTaskId={taskId}  // 重新编辑时
                    handleAddMore={handleAddMore}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    showSelectionColumn={showSelectionColumn}
                    setShowSelectionColumn={setShowSelectionColumn}
                    footerBarRef={footerBarRef}
                    getSmartDetailNum={getSmartDetailNum}
                    setSmartDetailReferLoading={setSmartDetailReferLoading} />
                {projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && (
                    <div className={styles.ConfigToolbar}>
                        <SmartDetailPageConfigBar
                            onOpenModelDrawer={handleOpenSmartDetailModelDrawer}
                            hasSelectedModel={selectedModelList.length > 0}
                            selectedModelUrl={selectedModelList?.[0]?.url}
                            itemList={smartDetailConfigItems}
                            onChange={handleSmartDetailConfigChange}
                        />
                    </div>
                )}
                <div className={styles.ConfigFooter}>
                    <FooterBar
                        ref={footerBarRef}
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        isEdit={isEdit}
                        projectId={projectId}
                        projectType={projectType}
                        handleRemove={(...args) => tableRef.current?.handleRemove?.(...args)}
                        listSkuByProject={listSkuByProject}
                        openReferenceDrawer={(...args) => tableRef.current?.openReferenceDrawer?.(...args)}
                        getBatchMode={(...args) => tableRef.current?.getBatchMode?.(...args)}
                        uploading={uploading}
                        selectedRowKeys={selectedRowKeys}
                        selectedRows={selectedRows}
                        setShowSelectionColumn={setShowSelectionColumn}
                        setSelectedRowKeys={setSelectedRowKeys}
                        setSelectedRows={setSelectedRows}
                        onAddMore={() => setUploadOpen(true)}
                        total={total}
                        skuNumber={dataSource.length}
                        editSkuId={skuId}
                        editTaskId={taskId}
                        smartDetailConfigItems={smartDetailConfigItems}
                        smartDetailReferLoading={smartDetailReferLoading}
                    />
                </div>
                {
                    uploading && <div className={styles.uploadNumber}>
                        <p><span>{remainUploadLength} / {uploadFileList.length} 正在上传</span> <span onClick={handleUploadAbort}>停止</span></p>
                        <Progress percent={Math.ceil(remainUploadLength / uploadFileList.length * 100)} showInfo={false} />
                    </div>
                }
            </div>
            <PSAIModal
                open={errorOpen}
                title="以下图像不符合大小或格式要求，未能成功上传"
                okText={allUploadFail ? "重新上传" : "确定"}
                cancelText={allUploadFail ? "回到入口" : "继续上传"}
                maxWidth={520}
                onOk={allUploadFail ? handleReupload : handleCancel}
                onCancel={allUploadFail ? handleGoBack : handleReupload}
                onClose={() => setErrorOpen(false)}
            >
                {
                    <div className={styles.ErrorUploadNotice2}>
                        {
                            projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? (
                                <p>请上传不大于10M，分辨率不小于300*300px，长宽比介于 1:2.5~2.5:1 之间的JPG/PNG/WEBP图片</p>
                            ) : (
                                <p>
                                    请上传不大于30M，分辨率不小于500*500px，长宽比不超过2:1，
                                    JPG/PNG/WEBP图片
                                </p>
                            )
                        }
                        <ul className="_beauty_scrollbar">
                            {
                                errorList.map((item, index) => (
                                    <li key={index}>{item.name}</li>
                                ))
                            }
                        </ul>
                    </div>
                }
            </PSAIModal>
            <PSAIModal
                title="添加源素材"
                maxWidth={950}
                open={uploadOpen}
                footer={null}
                onCancel={() => setUploadOpen(false)}
            >
                <UploadBox
                    projectType={projectType}
                    onUpload={handleAddMore}
                    onMyProjectUpload={handleMyProjectUpload}
                />
            </PSAIModal>
            <Drawer
                closable={false}
                onClose={() => setModelDrawerOpen(false)}
                open={modelDrawerOpen}
                width={1700}
                destroyOnHidden={true}
            >
                <SelectTryonPose
                    setDrawOpen={setModelDrawerOpen}
                    drawOpen={modelDrawerOpen}
                    maxCount={1}
                    projectType={BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH}
                    value={selectedModelList}
                    onChange={handleSmartDetailModelChange}
                    onClose={() => setModelDrawerOpen(false)}
                />
            </Drawer>
        </>

    )
}

export default ConfigPage
